import { flowRight } from 'lodash';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';
import { withTheme } from 'styled-components';

import { getThemeParameters } from '../../../../../../config/theme/selector';
import { SELECTED_INSURANCE } from '../../../../../../gql/selected-insurance';
import { getSearchParameters } from '../../../../../state';
import { trackReviewsReadMoreToggle } from '../../../../../actions';
import View from './CompactDoctorCard';

const withSelectedInsurance = Component => graphql(SELECTED_INSURANCE, {
    options: {
        notifyOnNetworkStatusChange: true,
    },
    skip: props => props.carrierId === '-1' || props.planId === '-1' || props.provider.isPreview,
})(Component);

const mapStateToProps = state => {
    const parameters = getSearchParameters(state);
    const theme = getThemeParameters(state);

    return {
        carrierId: parameters.carrierId,
        directoryId: theme.directoryId,
        planId: parameters.planId,
    };
};

const mapDispatchToProps = {
    trackReviewsReadMoreToggle,
};

export default flowRight(
    withTheme,
    connect(mapStateToProps, mapDispatchToProps),
    withSelectedInsurance,
)(View);
